import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import Filters from '../../components/Filters';
import PlansResults from './PlansResults';

const sortOptions = [
  { title: 'Price High To Low', field: 'price', dir: 'desc' },
  { title: 'Price Low To High', field: 'price' },
  { title: 'Stories', field: 'stories' },
  { title: 'Name', field: 'name' },
  { title: 'SQFT High To Low', field: 'sqft', dir: 'desc' },
  { title: 'SQFT Low To High', field: 'sqft' },
];

class Plans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  render() {
    const { page } = this.props;
    const { sort } = this.state;

    return (
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          background={get(page, 'page_image.contentUrl')}
          h1="Floor Plans"
        />
        <MenuAbout />
        <Filters
          type="plans"
          filterOptions={[
            {
              type: 'MultiSelect',
              filter: 'Beds',
              title: 'Beds',
              placeholder: 'All Beds',
            },
            {
              type: 'MultiSelect',
              filter: 'Baths',
              title: 'Baths',
              placeholder: 'All Baths',
            },
            {
              type: 'MultiSelect',
              filter: 'Sqft',
              title: 'Square Feet',
              placeholder: 'All Square Feet',
            },
          ]}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
        />
        <PlansResults sort={sort} />
      </PageWrapper>
    );
  }
}

Plans.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'floor_plans',
  },
)(Plans);



// WEBPACK FOOTER //
// ./src/pages/Plans/index.js